import React, { useEffect, useState, useRef } from "react";
import ChatUserList from "./ChatUSerList/index";
import SendIcon from "@mui/icons-material/Send";
import GroupsIcon from "@mui/icons-material/Groups";

import {
  BottomDiv,
  Chat,
  ChatDiv,
  Container,
  Icon,
  MessageArea,
  MessageInput,
} from "./styles";
import {
  BoldLg,
  BoldLgPri,
  HorizontalLeftAlign,
  RegMed,
  RegSm,
  SpaceBetween,
  VerticalLeftAlign,
} from "../../Components/CustomStyles";
import { Dot } from "../../Components/SideBar/style";
import Colors from "../../Constant/Colors";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import CloseIcon from "@mui/icons-material/Close";
import { setOpenChat } from "../../Redux/actions/auth";
import { useDispatch } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";

const DirectMessage = ({ course_id, title }) => {
  const dispatch = useDispatch();
  const { userName, chatGroupTitle, isInstructor, token } = useSelector(
    (state) => state.auth
  );
  const { courseUsers, oldMessages, courseChatLoading } = useSelector(
    (state) => state.home
  );

  const [loading, setLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [messageInp, setMessage] = useState("");
  const scrollViewRef = useRef();
  const [socket, setSocket] = useState([]);

  useEffect(() => {
    // Scroll to the bottom whenever messages are updated
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTop = scrollViewRef.current.scrollHeight;
    }
  }, [oldMessages, messages]);

  const renderMessages = (msgs) => {
    return msgs.map((msg, index) => {
      const date = dayjs(msg.timestamp).format("DD MMM YYYY, hh:mm a");

      return (
        <ChatDiv
          isRight={
            msg?.user?.username
              ? msg?.user?.username === userName
              : msg?.user === userName
          }
          key={index}
        >
          <Chat>
            <BoldLgPri>{msg?.user?.first_name ?? msg?.first_name}</BoldLgPri>
            <RegMed>{msg.message}</RegMed>
          </Chat>
          <RegSm style={{ color: Colors.lightGray, margin: 5 }}>{date}</RegSm>
        </ChatDiv>
      );
    });
  };

  const textareaRef = useRef(null);

  const handleInput = (event) => {
    const textarea = textareaRef.current;
    textarea.style.height = "auto"; // Reset the height
    textarea.style.height = `${textarea.scrollHeight}px`; // Set the height to match the scroll height
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      sendMessage(messageInp);
    }
  };

  const sendMessage = () => {
    if (socket && messageInp.trim()) {
      let mess = {
        message: messageInp,
      };

      socket.send(JSON.stringify(mess));
      setMessage(""); // Clear input after sending
    }
  };

  useEffect(() => {
    const textarea = textareaRef.current;
    if (messageInp === "") {
      textarea.style.height = "30px"; // Reset height to min-height after clearing
    }
  }, [messageInp]);

  useEffect(() => {
    // Create WebSocket connection.
    const ws = new WebSocket(
      `${process.env.REACT_APP_CHAT_WEB_SOCKET}${course_id}/?token=${token}`
    );

    // Set the WebSocket connection in state
    setSocket(ws);

    // Connection opened
    ws.onopen = () => {
      // console.log("WebSocket is connected.");
    };

    // Listen for messages
    ws.onmessage = (event) => {
      const newMessage = JSON.parse(event.data);
      setMessages((prevMessages) => [...prevMessages, newMessage]);
    };

    // Handle any errors
    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };

    // Clean up the connection when the component unmounts
    return () => {
      ws.close();
    };
  }, [course_id]);

  // useEffect(() => {
  //   const ws = new WebSocket(
  //     `${process.env.REACT_APP_CHAT_WEB_SOCKET}${course_id}/?token=${token}`
  //   );
  //   ws.close();
  // }, [course_id]);

  useEffect(() => {
    setMessages([]);
  }, [title, oldMessages]);


  const oncloseChat = () => {
    dispatch(setOpenChat(false, {}));
  };

  return (
    <SpaceBetween style={{ height: "100%" }}>
      <Container isInstructor={isInstructor}>
        <SpaceBetween style={{ marginTop: 10 }}>
          <HorizontalLeftAlign style={{ paddingBottom: 5 }}>
            <GroupsIcon
              style={{ color: Colors.primary, fontSize: 30, padding: 2 }}
            />
            <VerticalLeftAlign style={{ marginLeft: 10 }}>
              <BoldLg>{title}</BoldLg>
              <HorizontalLeftAlign>
                <Dot isActive={courseUsers?.instructor?.active} />
                <RegMed style={{ marginLeft: 10 }}>
                  {courseUsers?.instructor?.active ? "Active" : "In-active"}
                </RegMed>
              </HorizontalLeftAlign>
            </VerticalLeftAlign>
          </HorizontalLeftAlign>
          <span onClick={oncloseChat} style={{ cursor: "pointer" }}>
            <CloseIcon />
          </span>
        </SpaceBetween>
        <MessageArea ref={scrollViewRef}>
          {courseChatLoading ? (
            <div
              style={{
                width: '100%',
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <ClipLoader color={Colors.primary} size={20} />
            </div>
          ) : (
            <>
              {renderMessages(oldMessages)}
              {renderMessages(messages)}
            </>
          )}
        </MessageArea>
        <BottomDiv>
          <SpaceBetween>
            <MessageInput
              type="text"
              ref={textareaRef}
              onInput={handleInput}
              placeholder="Write Message"
              value={messageInp}
              onKeyDown={handleKeyDown}
              onChange={(e) => setMessage(e.target.value)}
            />
            <Icon tabIndex={0} onClick={sendMessage}>
              <SendIcon style={{ color: "#fff", fontSize: 20 }} />{" "}
            </Icon>
          </SpaceBetween>
        </BottomDiv>
      </Container>
      <ChatUserList
        instructor={courseUsers?.instructor}
        students={courseUsers?.students}
      />
    </SpaceBetween>
  );
};

const ChatComp = ({ id, title }) => {
  return <DirectMessage course_id={id} title={title} />;
};

export default ChatComp;

const styles = {
  customHeaderStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    height: 50,
    backgroundColor: "white",
    alignItems: "center",
    paddingLeft: 20,
    width: "100%",
    marginTop: 20,
  },
  headerLeft: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    background: "none",
    border: "none",
    cursor: "pointer",
  },
  headerTitle: {
    fontSize: 18,
    marginLeft: -35,
  },
  chatAbs: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "white",
    alignItems: "center",
    width: "100%",
    alignSelf: "center",
  },
  inputAbs: {
    width: "85%",
    alignSelf: "center",
    backgroundColor: "white",
    height: 50,
    color: "#666",
    paddingHorizontal: 20,
  },
  mainMsg: {
    paddingBottom: 25,
  },
  rightMsg: {
    maxWidth: "85%",
    minWidth: 150,
    backgroundColor: "#6661",
    padding: "10px",
    minHeight: 40,
    borderRadius: 8,
    justifyContent: "center",
    alignSelf: "flex-end",
    marginRight: 10,
    marginBottom: 20,
    marginTop: -10,
  },
  leftMsg: {
    maxWidth: "85%",
    minWidth: 150,
    backgroundColor: "#333",
    padding: "10px",
    minHeight: 40,
    borderRadius: 8,
    justifyContent: "center",
    alignSelf: "flex-start",
    marginLeft: 10,
    marginBottom: 20,
    marginTop: -10,
  },
  rightMsgTime: {
    alignSelf: "flex-end",
    marginRight: 10,
    fontSize: 12,
    color: "#888",
    marginBottom: 10,
  },
  leftMsgTime: {
    alignSelf: "flex-start",
    marginLeft: 10,
    fontSize: 12,
    color: "#888",
    marginBottom: 10,
  },
  listStyles: {
    flex: 1,
    overflowY: "scroll",
    paddingTop: 10,
    paddingBottom: 10,
  },
};
